var _circle, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotRegisteredIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 15,
    viewBox: "0 0 22 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 5.44495,
    cy: 3.6637,
    r: 3.1637,
    stroke: "#14142B"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.43949 14.2645C6.71275 14.2645 7.88849 14.059 8.76438 13.7086C9.20094 13.534 9.58778 13.3135 9.87366 13.0432C10.1606 12.7718 10.379 12.4157 10.379 11.9887C10.379 11.5617 10.1606 11.2055 9.87366 10.9342C9.58778 10.6638 9.20094 10.4434 8.76438 10.2688C7.88849 9.91842 6.71275 9.71289 5.43949 9.71289C4.16623 9.71289 2.99049 9.91842 2.1146 10.2688C1.67804 10.4434 1.2912 10.6638 1.00532 10.9342C0.718388 11.2055 0.5 11.5617 0.5 11.9887C0.5 12.4157 0.718388 12.7718 1.00532 13.0432C1.2912 13.3135 1.67804 13.534 2.1146 13.7086C2.99049 14.059 4.16623 14.2645 5.43949 14.2645Z",
    stroke: "#14142B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5582 3.42515C18.5582 2.8832 18.1246 2.44336 17.5903 2.44336C17.056 2.44336 16.6224 2.8832 16.6224 3.42515L16.6223 5.06709L14.9523 5.06814C14.418 5.06814 13.9844 5.50798 13.9844 6.04992C13.9844 6.59187 14.418 7.03171 14.9523 7.03171L16.6223 7.03066L16.6224 8.67575C16.6224 9.21769 17.056 9.65753 17.5903 9.65753C18.1246 9.65753 18.5582 9.21769 18.5582 8.67575L18.5581 7.03066L20.2306 7.03171C20.7649 7.03171 21.1986 6.59187 21.1986 6.04992C21.1986 5.50798 20.7649 5.06814 20.2306 5.06814L18.5581 5.06709L18.5582 3.42515Z",
    fill: "#14142B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotRegisteredIcon);
export default __webpack_public_path__ + "static/media/NotRegisteredIcon.da0ed99ac53d1d9e9b21dbbf1309e895.svg";
export { ForwardRef as ReactComponent };